import { AbstractControl } from '@angular/forms';

export function phoneValidator(control: AbstractControl): { [key: string]: any } | null {
  let phone: string = control.value;
  let phoneValid: boolean;

  if (phone && phone !== '') {
    phone = phone.replace(/\s+/g, ''); // remove spaces
    const regex = /^[\d +]+$/;
    if (!regex.test(phone)) {
      return { invalidNumber: { valid: false, value: control.value } };
    }
    if (phone.length === 12 && phone.startsWith('+41')) {
      // phone can be 12 digits long and start with +41 only
      phoneValid = true;
    } else {
      // otherwise is phone invalid
      phoneValid = false;
    }
  } else {
    phoneValid = true;
  }

  return phoneValid ? null : { invalidNumber: { valid: false, value: control.value } };
}
